export default __webpack_public_path__ + "static/media/yoga1.6a86a46a.jpg";